module.exports = __webpack_public_path__ + "static/img/leadsheet-standard.604b4ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leadsheet-standard.svg
// module id = 290
// module chunks = 0